import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const SquareCardListFocus = styled.div<{ fixed?: boolean }>`
  width: ${108 * Screen.widthRatio}px;
  height: ${108 * Screen.widthRatio}px;
  border: ${4 * Screen.widthRatio}px solid white;
  border-radius: ${20 * Screen.widthRatio}px;
  position: absolute;
  ${(props) =>
    props.fixed
      ? ` margin-left: ${-2 * Screen.widthRatio}px; 
          top: ${54 * Screen.widthRatio}px;`
      : ''}
`;

export default SquareCardListFocus;
